import { render, staticRenderFns } from "./actionsItem.vue?vue&type=template&id=1bc3a1d9&scoped=true"
import script from "./actionsItem.vue?vue&type=script&lang=js"
export * from "./actionsItem.vue?vue&type=script&lang=js"
import style0 from "./actionsItem.vue?vue&type=style&index=0&id=1bc3a1d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3a1d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc3a1d9')) {
      api.createRecord('1bc3a1d9', component.options)
    } else {
      api.reload('1bc3a1d9', component.options)
    }
    module.hot.accept("./actionsItem.vue?vue&type=template&id=1bc3a1d9&scoped=true", function () {
      api.rerender('1bc3a1d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/answer/actionsItem.vue"
export default component.exports